'use strict';

const SELECTORS = {
    NAVIGATION: '.concert-navigation',
    NAVIGATION_LINE: '.concert-navigation__line',
    NAVIGATION_LINK: '.concert-navigation__link',
    ACTIVE_LINK: '.concert-navigation__link.active',
}

const CLASSES = {
    ACTIVE: 'active',
}

let left = 0;
let width = 0;
// let animating = false;

export function setUnderline() {
    const navigationLine = document.querySelector(SELECTORS.NAVIGATION_LINE);
    const activeLink = document.querySelector(SELECTORS.ACTIVE_LINK);

    if (activeLink && navigationLine) {
        left = activeLink.getBoundingClientRect().left;
        width = activeLink.getBoundingClientRect().width;

        navigationLine.style.left = activeLink.offsetLeft + 'px';
        navigationLine.style.width = width + 'px';
    }
}

export function underline(element) {
    const navigation = document.querySelector(SELECTORS.NAVIGATION);
    const navigationLine = document.querySelector(SELECTORS.NAVIGATION_LINE);

    if (!navigation || !navigationLine || !element) {
        return;
    }

    // David - I've hidden this part, if the current element has the active class, the navigation line won't move
    // but we want it to move on screen resize here so this overwrites that and nothing happens
    // if (element.classList.contains(CLASSES.ACTIVE) || animating === true) {
    //     return;
    // }

    // animating = true;

    navigation.querySelectorAll(SELECTORS.NAVIGATION_LINK).forEach(link => {
        link.classList.remove(CLASSES.ACTIVE);
    });

    element.classList.add(CLASSES.ACTIVE);

    let elementPosition = element.getBoundingClientRect();
    let elementWidth = elementPosition.width;

    if (elementPosition.x >= left) {
        navigationLine.style.width = elementPosition.x - left + elementWidth + 'px';

        setTimeout(function () {
            navigationLine.style.left = element.offsetLeft + 'px';
            navigationLine.style.width = elementWidth + 'px';
            navigationLine.style.transitionDuration = '200ms';

            // animating = false;
        }, 300);
    } else {
        navigationLine.style.width = left - elementPosition.left + width + 'px';
        navigationLine.style.left = element.offsetLeft + 'px';

        setTimeout(function () {
            navigationLine.style.width = width + 'px';
            navigationLine.style.transitionDuration = '200ms';

            // animating = false;
        }, 300);
    }

    left = elementPosition.left;
    width = elementWidth;
}

export function init() {
    setUnderline();

    let resizeDebounce;
    let scrollDebounce;

    window.addEventListener('resize', function () {
        clearTimeout(resizeDebounce);

        resizeDebounce = setTimeout(function () {
            underline(document.querySelector(SELECTORS.ACTIVE_LINK));
        }, 150);
    });

    window.addEventListener('scroll', function () {
        clearTimeout(scrollDebounce);

        scrollDebounce = setTimeout(function () {
            document.querySelectorAll(SELECTORS.NAVIGATION_LINK).forEach(element => {
                const navigation = document.querySelector(SELECTORS.NAVIGATION);
                const target = document.querySelector(element.hash);

                if (!navigation || !target) {
                    return;
                }

                const scrollOffset = element.dataset.scrollOffset;
                const targetDimensions = target.getBoundingClientRect();
                const navigationHeight = navigation.getBoundingClientRect().height;

                let targetTop = targetDimensions.top;

                if (scrollOffset) {
                    targetTop = targetTop - scrollOffset;
                }

                if (targetTop <= navigationHeight && (targetTop + targetDimensions.height) > navigationHeight) {
                    underline(element);
                }
            });
        }, 150);
    });
}

export default { init }
